export const waitForMs = (time: number) => {
    return new Promise(resolve => {
        const timer = setTimeout(() => {
            resolve('done');
        }, time);
        return timer;
    });
};
